import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShareForShareSettings_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, commentingEnabled: boolean, downloadingEnabled: boolean, access?: Types.ShareAccess | null, passphrase?: string | null, enabled: boolean, name: string, showAssetNameInReelLayout: boolean };

export type ShareForShareSettings_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, commentingEnabled: boolean, downloadingEnabled: boolean, access?: Types.ShareAccess | null, passphrase?: string | null, enabled: boolean, name: string, showAssetNameInReelLayout: boolean };

export type ShareForShareSettingsFragment = ShareForShareSettings_AdHocAssetsShare_Fragment | ShareForShareSettings_CollectionShare_Fragment;

export const ShareForShareSettings = /*#__PURE__*/ gql`
    fragment ShareForShareSettings on Share {
  id
  commentingEnabled
  downloadingEnabled
  access
  passphrase
  enabled
  name
  showAssetNameInReelLayout
}
    ` as unknown as DocumentNode<ShareForShareSettingsFragment, unknown>;

        

        
export const useShareForShareSettingsFragment = (
  input: string | Omit<UseFragmentOptions<ShareForShareSettingsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareForShareSettingsFragment>({
    fragment: ShareForShareSettings,
    fragmentName: 'ShareForShareSettings',
    ...options,
  });
};
  
        